const SET_LOCATION = 'location/SET_LOCATION'
const FETCH_LOCATION = 'location/FETCH_LOCATION'
const SET_LAST_UPDATE_STATUS = 'location/SET_LAST_UPDATE_STATUS'
const SET_TRACKING = 'location/SET_TRACKING'

export {
  SET_LOCATION,
  SET_TRACKING,
  SET_LAST_UPDATE_STATUS,
  FETCH_LOCATION
}
